export enum EPristupPlatnost {
    REGISTRACE = 'REGISTRACE',
    LOGIN = 'LOGIN',
    NELZE = 'NELZE'
}
